export function toTitleCase(str) {
  return str.replaceAll(
    /\w\S*/g,
    function (txt) {
      return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase();
    }
  );
}